var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrd001EditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M11.9478 18.4428H19.2004",
    stroke: "#0050AE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9802 1.79479C11.7558 0.867787 13.1502 0.731856 14.0964 1.49173C14.1487 1.53296 15.8297 2.83879 15.8297 2.83879C16.8692 3.46719 17.1922 4.80311 16.5496 5.82259C16.5155 5.87718 7.01214 17.7645 7.01214 17.7645C6.69597 18.1589 6.21603 18.3918 5.7031 18.3973L2.06372 18.443L1.24373 14.9723C1.12886 14.4843 1.24373 13.9718 1.5599 13.5773L10.9802 1.79479Z",
    stroke: "#0050AE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 5",
    d: "M9.22119 4.00098L14.6734 8.1881",
    stroke: "#0050AE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrd001EditIcon);
export default __webpack_public_path__ + "static/media/ord_001_edit_icon.5b8c19bbcb69fd19cfe43a4ad962c2cd.svg";
export { ForwardRef as ReactComponent };